import React from 'react';

import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

enum ArrowType {
  up = 'arrowUp',
  down = 'arrowDown',
  left = 'arrowLeft',
  right = 'arrowRight',
}

interface ArrowProps extends IconProps {
  type: ArrowType;
}

const Arrow = (type: ArrowType): string => {
  const classes = useStyles();
  return classes[type];
};

const ArrowIcon = ({ type, ...rest }: ArrowProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes[type]} {...rest} />;
};

export const ArrowUp = (): string => Arrow(ArrowType.up);
export const ArrowDown = (): string => Arrow(ArrowType.down);
export const ArrowLeft = (): string => Arrow(ArrowType.left);
export const ArrowRight = (): string => Arrow(ArrowType.right);

export const ArrowUpIcon = (props: IconProps): JSX.Element => (
  <ArrowIcon type={ArrowType.up} {...props} />
);
export const ArrowDownIcon = (props: IconProps): JSX.Element => (
  <ArrowIcon type={ArrowType.down} {...props} />
);
export const ArrowLeftIcon = (props: IconProps): JSX.Element => (
  <ArrowIcon type={ArrowType.left} {...props} />
);
export const ArrowRightIcon = (props: IconProps): JSX.Element => (
  <ArrowIcon type={ArrowType.right} {...props} />
);
